var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/renderNodeIcon.tsx";
import { AssemblyFilled, Checkup, Folder } from '@gmini/ui-kit';
import { assertNever } from '@gmini/utils';
import { BimNodeIcon } from "../../../classifier-editor/ClassifierTree/BimNodeIcon";
import { jsx as _jsx } from "react/jsx-runtime";
export var renderNodeIcon = function renderNodeIcon(type) {
  switch (type) {
    case 'AssemblyClassifierNode':
    case 'AnonymousClassifierNode':
      return /*#__PURE__*/_jsx(AssemblyFilled, {});

    case 'UserClassifierNode':
      return /*#__PURE__*/_jsx(Checkup, {});

    case 'UserClassifierEmptyGroupNode':
    case 'UserClassifierGroupWithElementsNode':
    case 'UserClassifierGroupWithGroupsNode':
      return /*#__PURE__*/_jsx(Folder, {});

    case 'BimCategoryNode':
    case 'BimFamilyNode':
    case 'BimModelNode':
    case 'BimStandardSizeNode':
      return /*#__PURE__*/_jsx(BimNodeIcon, {
        type: type
      });

    case 'ALL_MODELS':
      return /*#__PURE__*/_jsx(BimNodeIcon, {
        type: "BimFamilyNode"
      });

    default:
      return assertNever('Unexpected node type', type);
  }
};